<template>
  <el-dialog
    title="来款确认分配"
    :visible.sync="dialogVisible"
    width="700px"
    top="15px"
    @open="open"
    @close="close"
  >
    <el-table :data="tableData" border style="width: 100%" show-summary :summary-method="getSummaries">
      <el-table-column type="index" width="50" label="序号" align="left" />
      <el-table-column prop="contractNum" label="合同号" align="left" />
      <el-table-column prop="telegraphicTransferNo" label="电汇底单编号" align="left" />
      <el-table-column prop="actualSettlementAmount" label="实际结算金额" align="right" header-align="left" width="160px" />
      <el-table-column label="本次分配金额" align="right" header-align="left" width="160px">
        <template slot-scope="scope">
          {{ fun(scope.row.assignAmount) }}
        </template>
      </el-table-column>
    </el-table>
    <el-button type="primary" style="margin-top:20px" :loading="loading" @click="submit">
      确认分配
    </el-button>
  </el-dialog>
</template>

<script>
import { assignTelegraphicTransferInternation } from '@/API/index.js';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      tableData: [],
      loading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },

  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => { return {}; }
    },
    // 本次分配的总金额
    assignAllTotal: {
      type: Number,
      default: 0
    },
    // 项目详情
    info: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },

  methods: {
    fun (val) {
      return Number(val).toFixed(2);
    },
    open () {
      this.tableData = this.data.dialogData;
      this.tableData.forEach((item) => {
        // item.assignAmount = item.assignAmount.toFixed(2);
      });
      this.sureData = this.data;
    },

    close () {
      this.tableData = [];
    },

    // 合计行的计算
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.AssignAmount();
        }
      });
      return sums;
    },

    AssignAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += item.assignAmount;
      });
      return cont.toFixed(2);
    },

    // 提交分配的按钮
    submit () {
      if (this.assignAllTotal > this.info.actualSettlementAmount) {
        this.$message.warning('本次分配金额大于未分配金额，请进行调整');
        return;
      }

      let payList = [];
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          payList.push({
            telegraphicTransferNo: item.telegraphicTransferNo,
            assignAmount: item.assignAmount,
            businessEntity: item.businessEntity
          });
        }
      });

      if (!payList.length) {
        this.$message.warning('请输入相应的分配款项');
        return;
      }

      let params = {
        contractId: this.info.id,
        contractType: this.info.contractType,
        contractNum: this.info.contractNum,
        assignDetailList: payList
      };
      this.loading = true;
      assignTelegraphicTransferInternation(params).then((res) => {
        this.loading = false;
        let { status } = res.data;
        if (status === '200') {
          this.dialogVisible = false;
          this.$message.success('分配成功');
        }
      }).catch(() => {
        this.loading = false;
      });
    }

  }

};
</script>
